import { Col, Input, Row } from 'reactstrap';
import { DropdownList } from 'react-widgets/cjs';
import { ArrowDown } from '../../../../../../components/arrow-down/arrow-down';
import { useStateSelector } from '../../../../../../store/selectors';
import createNotification from '../../../../../../utils/createNotification';
import { DataForm } from '../../../../../../models/DataRequestHub/DataForm';
import { DataFormType } from '../../../../../../models/DataRequestHub/DataFormTypeEnum';
import ReactSwitch from 'react-switch';
import Helpers from '../../../../../../utils/helper';
import { TemplateDropdownOption } from '../../../../../../models/DataRequestHub/TemplateDropdownOption';
import { DataTable } from '../../../../../../models/DataRequestHub/DataTable';
import { CreateDataTableForm } from '../../CreateDataTableForm/CreateDataTableForm';
import React, { Dispatch, SetStateAction, useState, useEffect } from 'react';
import './DefineNewProjectTablesForm.scss';

interface DefineNewProjectTablesFormProps {
    isDocumentDataFormVisible: boolean;
    setIsDocumentDataFormVisible: Dispatch<SetStateAction<boolean>>;
    selectedDocumentTemplateId?: number;
    setSelectedDocumentTemplateId: Dispatch<SetStateAction<number>>;

    isFinancialRequestsDataFormVisible: boolean;
    setIsFinancialRequestsDataFormVisible: Dispatch<SetStateAction<boolean>>;
    selectedfinafinancialRequestsTemplateId?: number;
    setSelectedFinancialRequestsTemplateId: Dispatch<SetStateAction<number>>;

    isQuestionnaireDataFormVisible: boolean;
    setIsQuestionnaireDataFormVisible: Dispatch<SetStateAction<boolean>>;
    selectedQuestionnaireTemplateId: number;
    setSelectedQuestionnaireTemplateId: Dispatch<SetStateAction<number>>;
    questionnaireFormName?: string;
    setQuestionnaireFormName: Dispatch<SetStateAction<string>>;
    setQuestionnaireForms: Dispatch<SetStateAction<DataForm[]>>;
    getTableViewsByQuestionnaireId: (questionnaireId: number) => number[];
    getTablesByQuestionnaireId: (questionnaireId: number) => number[];

    isDataTablesVisible: boolean;
    setIsDataTablesVisible: Dispatch<SetStateAction<boolean>>;
    setSelectedDataTableViewTemplateIds: Dispatch<SetStateAction<number[]>>;
    selectedDataTableViewTemplateIds: number[];
    setDataTables: Dispatch<SetStateAction<DataTable[]>>;
    setSelectedDataTableTemplateIds: Dispatch<SetStateAction<number[]>>;
    dataTables: DataTable[];
    selectedDataTableTemplateIds: number[];

    disabled?: boolean;
}
export const DefineNewProjectTablesForm = (
    props: DefineNewProjectTablesFormProps
) => {
    const axios = useStateSelector((state) => state.core.axios);

    const [documentTemplateOptions, setDocumentTemplateOptions] = useState<
        TemplateDropdownOption[]
    >([]);
    const [
        financialRequestsTemplateOptions,
        setFinancialRequestsTemplateOptions,
    ] = useState<TemplateDropdownOption[]>([]);
    const [questionnaireTemplateOptions, setQuestionnaireTemplateOptions] =
        useState<TemplateDropdownOption[]>([]);
    const [dataTableTemplateOptions, setDataTableTemplateOptions] = useState<
        TemplateDropdownOption[]
    >([]);

    useEffect(() => {
        fetchTemplateOptions();
    }, []);

    const renderDataFormFields = () => {
        return (
            <>
                <Row>
                    <Col md={6}>
                        <div className="field-switcher">
                            <ReactSwitch
                                offColor="#d92550"
                                checked={props.isDocumentDataFormVisible}
                                onChange={(event) => {
                                    props.setIsDocumentDataFormVisible(event);
                                }}
                                height={22}
                                disabled={props.disabled}></ReactSwitch>
                            <div className="field-label">Document Template</div>
                        </div>
                    </Col>
                    <Col md={6}>
                        <DropdownList
                            selectIcon={<ArrowDown />}
                            disabled={
                                !props.isDocumentDataFormVisible ||
                                props.disabled
                            }
                            data={documentTemplateOptions}
                            defaultValue={
                                props.selectedDocumentTemplateId ??
                                documentTemplateOptions[0]
                            }
                            onChange={(value) => {
                                handleDocumentTemplateOptionChange(value.id);
                            }}
                            dataKey="id"
                            filter="contains"
                            textField="name"
                        />
                    </Col>
                </Row>
                <Row>
                    <Col md={6}>
                        <div className="field-switcher">
                            <ReactSwitch
                                offColor="#d92550"
                                checked={
                                    props.isFinancialRequestsDataFormVisible
                                }
                                onChange={(event) => {
                                    props.setIsFinancialRequestsDataFormVisible(
                                        event
                                    );
                                }}
                                height={22}
                                disabled={props.disabled}></ReactSwitch>
                            <div className="field-label">
                                Financial Requests Template
                            </div>
                        </div>
                    </Col>
                    <Col md={6}>
                        <DropdownList
                            selectIcon={<ArrowDown />}
                            disabled={
                                !props.isFinancialRequestsDataFormVisible ||
                                props.disabled
                            }
                            data={financialRequestsTemplateOptions}
                            defaultValue={
                                props.selectedfinafinancialRequestsTemplateId ??
                                financialRequestsTemplateOptions[0]
                            }
                            onChange={(value) => {
                                handleFinancialRequestsTemplateOptionChange(
                                    value.id
                                );
                            }}
                            dataKey="id"
                            filter="contains"
                            textField="name"
                        />
                    </Col>
                </Row>
                <Row>
                    <Col md={6}>
                        <div className="field-switcher">
                            <ReactSwitch
                                offColor="#d92550"
                                checked={props.isQuestionnaireDataFormVisible}
                                onChange={(event) => {
                                    props.setIsQuestionnaireDataFormVisible(
                                        event
                                    );
                                }}
                                height={22}
                                disabled={props.disabled}></ReactSwitch>
                            <div className="field-label">Questionnaire</div>
                        </div>
                    </Col>
                    <Col md={6} className="questionnaire-section-input">
                        <DropdownList
                            selectIcon={<ArrowDown />}
                            disabled={
                                !props.isQuestionnaireDataFormVisible ||
                                props.disabled
                            }
                            data={questionnaireTemplateOptions}
                            defaultValue={
                                props.selectedQuestionnaireTemplateId ??
                                questionnaireTemplateOptions[0]
                            }
                            onChange={(value) => {
                                handleQuestionnaireTemplateOptionChange(
                                    value.id
                                );
                            }}
                            dataKey="id"
                            filter="contains"
                            textField="name"
                        />

                        <Input
                            disabled={
                                !props.isQuestionnaireDataFormVisible ||
                                props.disabled
                            }
                            defaultValue={props.questionnaireFormName ?? ''}
                            placeholder="Optional..."
                            onChange={(event) => {
                                props.setQuestionnaireFormName(
                                    event.target.value.trim()
                                );
                            }}
                        />
                    </Col>
                </Row>
            </>
        );
    };

    const renderDataTableField = () => {
        return (
            <CreateDataTableForm
                isDataTablesVisible={props.isDataTablesVisible}
                setIsDataTablesVisible={props.setIsDataTablesVisible}
                getTableMultiselectOptions={getDataTableMultiselectOptions}
                selectedDataTableTemplateIds={
                    props.selectedDataTableTemplateIds
                }
                handleDataTableTemplateOptionsChange={
                    handleDataTableTemplateOptionsChange
                }
                getDataTableViewMultiselectOptions={
                    getDataTableViewMultiselectOptions
                }
                selectedDataTableViewTemplateIds={
                    props.selectedDataTableViewTemplateIds
                }
                handleDataTableViewTemplateOptionsChange={
                    handleDataTableViewTemplateOptionsChange
                }
                getTableViewsByQuestionnaireId={() => {
                    return props.getTableViewsByQuestionnaireId(
                        props.selectedQuestionnaireTemplateId
                    );
                }}
                getTablesByQuestionnaireId={() => {
                    return props.getTablesByQuestionnaireId(
                        props.selectedQuestionnaireTemplateId
                    );
                }}
                setSelectedDataTableViewTemplateIds={
                    props.setSelectedDataTableViewTemplateIds
                }
                setSelectedDataTableTemplateIds={
                    props.setSelectedDataTableTemplateIds
                }
                disabled={props.disabled}></CreateDataTableForm>
        );
    };

    const getFilteredDataFormTemplateOptions = (
        templateForms: DataForm[],
        targetFormType: DataFormType
    ): TemplateDropdownOption[] => {
        const result = templateForms
            .map((obj: DataForm) => ({
                id: obj.id,
                name: obj.originalTemplateName,
                formType: obj.formType,
            }))
            .filter((x) => x.formType === targetFormType)
            .sort((a, b) => Helpers.stringSortFunction(a.name, b.name));

        result.unshift({
            id: 0,
            name: 'None',
            formType: undefined,
        });

        return result;
    };

    const getMappedDataTableTemplateOptions = (
        templateTables: DataTable[]
    ): TemplateDropdownOption[] => {
        const result = templateTables
            .map((obj: DataTable) => ({
                id: obj.id,
                name: obj.originalTemplateName,
                formType: undefined as any,
            }))
            .sort((a, b) => Helpers.stringSortFunction(a.name, b.name));

        return result;
    };

    const getDataTableMultiselectOptions = () => {
        return dataTableTemplateOptions.map((x) => {
            return { id: x.id, option: x.name };
        });
    };

    const getDataTableViewMultiselectOptions = () => {
        const tables = props.dataTables.filter((table) =>
            props.selectedDataTableTemplateIds?.includes(table.id)
        );
        const tableViews = tables.flatMap((x) => x.views);

        return tableViews.map((view) => {
            const table = tables.find((table) =>
                table.views.some((v) => v.id === view.id)
            );
            const name = `${table?.name} - ${view.name}`;

            return { id: view.id, option: name };
        });
    };

    const handleDataTableTemplateOptionsChange = (templateIds: number[]) => {
        props.setSelectedDataTableTemplateIds(templateIds);
    };

    const handleDataTableViewTemplateOptionsChange = (
        templateIds: number[]
    ) => {
        props.setSelectedDataTableViewTemplateIds(templateIds);
    };

    const handleDocumentTemplateOptionChange = (templateId: number) => {
        props.setSelectedDocumentTemplateId(templateId);
    };

    const handleFinancialRequestsTemplateOptionChange = (
        templateId: number
    ) => {
        props.setSelectedFinancialRequestsTemplateId(templateId);
    };

    const handleQuestionnaireTemplateOptionChange = (templateId: number) => {
        const previousQuestionnaireId = props.selectedQuestionnaireTemplateId;
        props.setSelectedQuestionnaireTemplateId(templateId);
        updatePreselectedDataTables(templateId, previousQuestionnaireId);
        updatePreselectedDataTableViews(templateId, previousQuestionnaireId);
    };

    const updatePreselectedDataTables = (
        templateId: number,
        previousQuestionnaireId: number
    ) => {
        const uniqueTableIds = props.getTablesByQuestionnaireId(templateId);

        const uniquePreviousTableIds = props.getTablesByQuestionnaireId(
            previousQuestionnaireId
        );

        let updatedTables = (props.selectedDataTableTemplateIds ?? []).filter(
            (id) => !uniquePreviousTableIds.includes(id)
        );
        uniqueTableIds.forEach((id) => {
            if (!updatedTables.includes(id)) {
                updatedTables.push(id);
            }
        });
        props.setSelectedDataTableTemplateIds(updatedTables);
    };

    const updatePreselectedDataTableViews = (
        templateId: number,
        previousQuestionnaireId: number
    ) => {
        const uniqueTableViewIds =
            props.getTableViewsByQuestionnaireId(templateId);

        const uniquePreviousTableViewIds = props.getTableViewsByQuestionnaireId(
            previousQuestionnaireId
        );

        let updatedTableViews = (
            props.selectedDataTableViewTemplateIds ?? []
        ).filter((id) => !uniquePreviousTableViewIds.includes(id));
        uniqueTableViewIds.forEach((id) => {
            if (!updatedTableViews.includes(id)) {
                updatedTableViews.push(id);
            }
        });

        props.setSelectedDataTableViewTemplateIds(updatedTableViews);
    };

    const fetchTemplateOptions = () => {
        axios
            .get('/api/dataRequestTemplateProject/dataForms')
            .then((response) => {
                if (response.status === 200) {
                    const filteredDocumentTemplateOptions =
                        getFilteredDataFormTemplateOptions(
                            response.data,
                            DataFormType.Documents
                        );
                    setDocumentTemplateOptions(filteredDocumentTemplateOptions);

                    const filteredFinancalRequestsTemplateOptions =
                        getFilteredDataFormTemplateOptions(
                            response.data,
                            DataFormType.FinancialRequest
                        );

                    setFinancialRequestsTemplateOptions(
                        filteredFinancalRequestsTemplateOptions
                    );

                    const filteredQuestionnaireTemplateOptions =
                        getFilteredDataFormTemplateOptions(
                            response.data,
                            DataFormType.Questionnaire
                        );

                    setQuestionnaireTemplateOptions(
                        filteredQuestionnaireTemplateOptions
                    );

                    const questionnaireForms = response.data.filter(
                        (x: DataForm) =>
                            x.formType === DataFormType.Questionnaire
                    );
                    props.setQuestionnaireForms(questionnaireForms);
                } else {
                    createNotification(
                        'An error occured while fetching templates',
                        'error'
                    );
                }
            });

        axios
            .get('/api/dataRequestTemplateProject/dataTables')
            .then((response) => {
                if (response.status === 200) {
                    const filteredDataTableTemplateOptions =
                        getMappedDataTableTemplateOptions(response.data);

                    setDataTableTemplateOptions(
                        filteredDataTableTemplateOptions
                    );

                    props.setDataTables(response.data);
                } else {
                    createNotification(
                        'An error occured while fetching templates',
                        'error'
                    );
                }
            });
    };

    return (
        <div className="define-new-project-table-form">
            {renderDataFormFields()}
            {renderDataTableField()}
        </div>
    );
};
